// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"84f24bf8","453":"319aa5d5","455":"8cf5d740"}[chunkId] + ".chunk.js";
};